<template>
    <KFrame
        v-if="story"
        as="a"
        :href="`/${story.full_slug}`"
        :ratio="imageDimensions.ratio"
        rounded
        scrim
        class="image-link-grid-item"
        @click="trackClick"
    >
        <NuxtImg
            :width="imageDimensions.width"
            :height="imageDimensions.height"
            fit="cover"
            format="auto"
            loading="lazy"
            :src="story?.content?.image?.filename || item?.image?.filename"
            :alt="story?.content?.image?.alt || item?.image?.alt"
            class="image-link-grid-item__image"
        />

        <div class="image-link-grid-item__content">
            <h3 class="image-link-grid-item__text k-heading-4">
                {{ item.text }}
            </h3>

            <Icon
                aria-hidden="true"
                class="image-link-grid-item__arrow"
                name="tabler:arrow-right"
            />
        </div>
    </KFrame>
</template>

<script setup>
import { KFrame } from '@vemedia/karibu'
import { computed } from 'vue'

// `story` comes from the parent's single batched /api/pages-by-uuids request
// (see image-link-grid.vue) — this component no longer fetches per tile.
const props = defineProps({
    item: { type: Object, required: true },
    story: { type: Object, default: undefined },
    aspectRatio: { type: String, default: '16 / 9' },
})

const ASPECT_RATIOS = {
    '16 / 9': { ratio: '16 / 9', width: 320, height: 180 },
    '4 / 3': { ratio: '4 / 3', width: 320, height: 240 },
    '1 / 1': { ratio: '1 / 1', width: 320, height: 320 },
}

const imageDimensions = computed(() => ASPECT_RATIOS[props.aspectRatio] || ASPECT_RATIOS['16 / 9'])
const { capture } = useTracking()

function trackClick() {
    capture('content_card_clicked', {
        placement: 'image-link-grid',
        target_slug: props.story.full_slug,
    })
}
</script>
